import React, { ReactNode } from 'react'
import styled from 'styled-components'

import { Base } from 'src/components/ui/Base'
import { Container } from 'src/components/ui/Container'
import { themeEstra } from 'src/styles/themeEstra'

interface Props {
  children?: ReactNode
}

export const BlobCardHomeList: React.FC<Props> = ({ children }) => {
  return (
    <Base>
      <Container>
        <Wrapper>{children}</Wrapper>
      </Container>
    </Base>
  )
}

const Wrapper = styled.div`
  display: grid;
  gap: 2rem;
  @media (min-width: ${themeEstra.bp.tablet}) {
    grid-template-columns: 1fr 1fr;
    padding-top: 3rem;
  }

  @media (min-width: ${themeEstra.bp.desktop}) {
    padding-top: 0;
  }
`
